<template>
  <section class="chart-body">
    <section
      v-for="(data, index) in dataList"
      :key="index"
      class="chart-item"
    >
      <section class="chart-item-header">
        <span>{{data.name}}</span>
      </section>
      <section class="chart-item-body">
        <div style="padding-top: 5px;">
          <el-input size="small" type="number" v-model="data.min" style="width: 150px;" @input="dataListChange">
            <template slot="prepend">最低值</template>
          </el-input>
          <el-input size="small" type="number" v-model="data.max" style="width: 150px;" @input="dataListChange">
            <template slot="prepend">最高值</template>
          </el-input>
        </div>
        <div style="padding-bottom: 10px;">
          <key-line-chart
            ref="lineCharts"
            :data="{
              data: data.data,
              name: data.name,
              unit: data.unit,
              max: data.max,
              min: data.min,
              dataTimes: data.dataTimes
            }"
          />
        </div>
      </section>
    </section>
  </section>
</template>

<script>
import KeyLineChart from '../../../components/Data/keylinechart'
export default {
  name: 'ParameterChart',
  props: {
    data: {
      required: true,
      type: Array
    },
    deviceStatusUnitMap: {
      required: true,
      type: Object
    },
    deviceStatusMap: {
      required: true,
      type: Object
    }
  },
  components: {KeyLineChart},
  data () {
    return {
      dataList: []
    }
  },
  methods: {
    dataListChange () {
      this.renderCharts()
    },
    formaterChartData (data) {
      let {deviceStatusUnitMap} = this
      let deviceStatusMap = Object.values(this.deviceStatusMap).map(el => el).flat().reduce((map, el) => {
        map[el.deviceStatusId] = el

        return map
      }, {})

      let dataMap = data.reduce((map, el) => {
        if (deviceStatusMap[el.deviceStatusId] && deviceStatusMap[el.deviceStatusId].status) {
          if (!map[el.deviceStatusId]) {
            map[el.deviceStatusId] = {
              name: deviceStatusUnitMap[el.deviceStatusId] ? deviceStatusUnitMap[el.deviceStatusId].name : '',
              unit: deviceStatusUnitMap[el.deviceStatusId] ? deviceStatusUnitMap[el.deviceStatusId].unit : '',
              data: [],
              max: deviceStatusMap[el.deviceStatusId].isAlarm ? deviceStatusMap[el.deviceStatusId].alarmMax : '',
              min: deviceStatusMap[el.deviceStatusId].isAlarm ? deviceStatusMap[el.deviceStatusId].alarmMin : '',
              dataTimes: []
            }
          }

          map[el.deviceStatusId].data.push(el.value)
          map[el.deviceStatusId].dataTimes.push(el.dataTime)
        }

        return map
      }, {})

      this.dataList = Object.values(dataMap)
      this.renderCharts()
    },
    renderCharts () {
      setTimeout(() => {
        let charts = this.$refs.lineCharts
        if (charts && charts.length > 0) {
          charts.forEach(el => {
            el.render()
          })
        }
      }, 10)
    }
  },
  watch: {
    data: {
      immediate: true,
      handler (data) {
        this.formaterChartData(data)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-body {
  width: 100%;
  height: 100%;
  padding-top: 10px;
}

.chart-item-header {
  width: 100%;
  line-height: 1.8em;
  padding: 0 10px;
  background: -webkit-gradient(linear, left top, right top, from(#fbc15a), to(#fff));
  background: linear-gradient(to right, #fbc15a 0%, #fff 100%);
  color: #ffffff;
  font-weight: 600;
}

.chart-item-body {
  height: 450px;
  display: grid;
  grid-template-rows: 10% 90%;
  gap: 5px;
}
.el-date-editor {
  width: 165px;
}
</style>



// WEBPACK FOOTER //
// src/views/05QC-Analysis/01KeyParameter/ParameterChart.vue